import { Injectable, ViewContainerRef, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";

import { EditDialogComponent } from "./edit-dialog.component";

@Injectable()
export class EditDialogService {
  private dialog = inject(MatDialog);

  public edit(viewContainerRef: ViewContainerRef, name: string, existingNames?: Array<string>): Observable<string> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.data = { name: name, existingNames: existingNames };
    config.viewContainerRef = viewContainerRef;

    const dialogRef = this.dialog.open(EditDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
